import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}

import { computed } from 'vue'

    /* ---------------- props / emits ---------------- */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SurveyCloserDialog',
  props: {
    propOpened: { type: Boolean },
    propSurveyId: {}
  },
  emits: ["stop-survey", "close-dialog"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    /* ---------------- derived ---------------- */

    const opened = computed(() => props.propOpened)
    const surveyId = computed<number | null>(() => props.propSurveyId ?? null)

    /* ---------------- actions ---------------- */

    function stopSurvey()
    {
        emit('stop-survey', surveyId.value)
    }

    function close()
    {
        emit('close-dialog')
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", { class: "modal-wrapper" }, [
          _createElementVNode("div", { class: "modal-dialog modal-lg modal-dialog-scrollable" }, [
            _createElementVNode("div", { class: "modal-content" }, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Closing a survey", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-body" }, [
                _createElementVNode("p", { class: "lead" }, " You're about to close the survey. "),
                _createElementVNode("br")
              ], -1 /* CACHED */)),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: stopSurvey,
                  type: "button",
                  class: "btn btn-primary"
                }, "Close the survey"),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Cancel")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})